import useUrlParams from '../../../composables/useUrlParams';
import builder from '../../../shared/builders/dataLayer';

export default function useViewItemsListTags(paginator, productList = null, netwaveCategoryCode = null) {
  const { viewItemsListEvent, reset: resetBuilder } = builder();
  const params = useUrlParams();
  const isSearchPage = !productList;

  const listTags = () => {
    window.dataLayer.push(resetBuilder());
    let listId = `special-${productList?.id}`;
    if (isSearchPage) {
      listId = 'search';
    } else if (netwaveCategoryCode > 0) {
      listId = `category-${netwaveCategoryCode}`;
    }
    const listName = isSearchPage ? params.query : productList?.name;
    window.dataLayer.push(viewItemsListEvent(paginator?.data, listId, listName));
  };

  return { listTags };
}
